import { View, Text } from 'react-native';
import { Button } from './Button';
import { TextInput } from './TextInput';
import { DEFAULT_PURCHASE_GROWTH_RATE_PERCENT } from '../lib/life-events';

interface RecurringPurchaseFieldsProps {
  isRecurring: boolean;
  onSelectOneTime: () => void;
  onSelectRepeats: () => void;
  repeatEveryYears: string;
  onRepeatEveryYearsChange: (text: string) => void;
  endYear: string;
  onEndYearChange: (text: string) => void;
  growthRatePercent: string;
  onGrowthRatePercentChange: (text: string) => void;
  showEndYearInput?: boolean;
}

export function RecurringPurchaseFields({
  isRecurring,
  onSelectOneTime,
  onSelectRepeats,
  repeatEveryYears,
  onRepeatEveryYearsChange,
  endYear,
  onEndYearChange,
  growthRatePercent,
  onGrowthRatePercentChange,
  showEndYearInput = true,
}: RecurringPurchaseFieldsProps) {
  return (
    <View className="mb-3 rounded-xl border border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-3">
      <Text className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Purchase timing
      </Text>
      <View className="flex-row gap-2 mb-3">
        <Button
          size="sm"
          variant={!isRecurring ? 'primary' : 'secondary'}
          onPress={onSelectOneTime}
        >
          One time
        </Button>
        <Button
          size="sm"
          variant={isRecurring ? 'primary' : 'secondary'}
          onPress={onSelectRepeats}
        >
          Repeats
        </Button>
      </View>

      {isRecurring && (
        <>
          <View className="flex-row gap-2 mb-2">
            <TextInput
              label="Repeat every"
              value={repeatEveryYears}
              onChangeText={onRepeatEveryYearsChange}
              placeholder="Years"
              keyboardType="numeric"
              size="sm"
              containerClassName="flex-1"
            />
            {showEndYearInput && (
              <TextInput
                label="End year"
                value={endYear}
                onChangeText={onEndYearChange}
                placeholder="End year"
                keyboardType="numeric"
                size="sm"
                containerClassName="flex-1"
              />
            )}
            <TextInput
              label="Growth rate"
              value={growthRatePercent}
              onChangeText={onGrowthRatePercentChange}
              placeholder="%"
              keyboardType="numeric"
              size="sm"
              containerClassName="w-28"
            />
          </View>
          <Text className="text-xs text-gray-400 dark:text-gray-500">
            Each repeat grows by{' '}
            {growthRatePercent || DEFAULT_PURCHASE_GROWTH_RATE_PERCENT}% per
            year.
          </Text>
        </>
      )}
    </View>
  );
}
